import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
if (typeof document !== 'undefined') {
  // 1. Preload hero image — highest priority for LCP
  const preloadImg = document.createElement('link');
  preloadImg.rel = 'preload';
  preloadImg.as = 'image';
  preloadImg.href = 'https://cdn.magicpatterns.com/uploads/dM5UFAffnNvMXZNE2KbFmm/Coleccion_MEGAPACK__transforma_tu_mundo_interior_(1).jpg';
  document.head.insertBefore(preloadImg, document.head.firstChild);
  // 2. Google Fonts — non-blocking
  const fontLink = document.createElement('link');
  fontLink.rel = 'stylesheet';
  fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;600&family=Poppins:wght@700;800&display=swap';
  fontLink.media = 'print';
  fontLink.onload = function () {
    ;
    (this as HTMLLinkElement).media = 'all';
  };
  document.head.appendChild(fontLink);
  // 3. Single preconnect
  const preconnect = document.createElement('link');
  preconnect.rel = 'preconnect';
  preconnect.href = 'https://fonts.gstatic.com';
  preconnect.crossOrigin = 'anonymous';
  document.head.appendChild(preconnect);
  // 4. Meta Pixel — deferred
  if (!document.querySelector('[data-meta-pixel]')) {
    requestIdleCallback?.(() => {
      const s = document.createElement('script');
      s.setAttribute('data-meta-pixel', 'true');
      s.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','1413771729918296');fbq('track','PageView');`;
      document.head.appendChild(s);
    }) ?? setTimeout(() => {
      const s = document.createElement('script');
      s.setAttribute('data-meta-pixel', 'true');
      s.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','1413771729918296');fbq('track','PageView');`;
      document.head.appendChild(s);
    }, 4000);
  }
}
render(<App data-id="element-315" />, document.getElementById('root'));